import { Boiler } from "./equipmentTypes/Boiler";
import { CompCent } from "./equipmentTypes/CompCent";
import { CompRec } from "./equipmentTypes/CompRec";
import { EngineMono } from "./equipmentTypes/EngineMono";
import { EngineTri } from "./equipmentTypes/EngineTri";
import { GearBox } from "./equipmentTypes/GearBox";
import { GeneMono } from "./equipmentTypes/GeneMono";
import { GeneTri } from "./equipmentTypes/GeneTri";
import { HeatExchangerCooling } from "./equipmentTypes/HeatExchangerCooling";
import { HeatExchangerHeater } from "./equipmentTypes/HeatExchangerHeater";
import { Oven } from "./equipmentTypes/Oven";
import { PumpBB } from "./equipmentTypes/PumpBB";
import { PumpOH } from "./equipmentTypes/PumpOH";
import { PumpVS } from "./equipmentTypes/PumpVS";
import { Reactor } from "./equipmentTypes/Reactor";
import { TankCon } from "./equipmentTypes/TankCon";
import { TankFloat } from "./equipmentTypes/TankFloat";
import { TransformerMono } from "./equipmentTypes/TransformerMono";
import { TransformerTri } from "./equipmentTypes/TransformerTri";
import { TurbSteam } from "./equipmentTypes/TurbSteam";
import { TurbGas } from "./equipmentTypes/TurbGas";
import { MillingMachine4axis } from "./equipmentTypes/MillingMachine4axis";
import { MillingMachine5axis } from "./equipmentTypes/MillingMachine5axis";
import { LatheCNC } from "./equipmentTypes/LatheCNC";
import { LatheCycle } from "./equipmentTypes/LatheCycle";
export const equipmentType = [
  PumpOH,
  PumpBB,
  PumpVS,
  CompRec,
  CompCent,
  TurbSteam,
  TurbGas,
  EngineMono,
  EngineTri,
  GeneMono,
  GeneTri,
  GearBox,
  TankCon,
  TankFloat,
  Oven,
  Boiler,
  HeatExchangerCooling,
  HeatExchangerHeater,
  Reactor,
  TransformerMono,
  TransformerTri,
  MillingMachine5axis,
  MillingMachine4axis,
  LatheCNC,
  LatheCycle
];
